// extracted by mini-css-extract-plugin
export var addressFields = "_jh-0";
export var animationContainer = "_jh-1";
export var footer = "_jh-2";
export var lineItems = "_jh-3";
export var modalContent = "_jh-4";
export var orderName = "_jh-5";
export var strong = "_jh-6";
export var warning = "_jh-7";